import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

// استيراد الصور من مجلد assets
import leftArrowIcon from '../assets/left.png'; // أيقونة الرجوع
import backImage from '../assets/back.jpg'; // صورة الخلفية الافتراضية
import manImage from '../assets/man.jpg'; // صورة الرجل المريض (افتراضية)
import nooLogo from '../assets/noo.png'; // أيقونة Noo Logo
// تأكد من وجود هذه الصور في مجلد src/assets

const ShowPatient = () => {
  const { id } = useParams(); // لجلب معرف المريض من URL
  const navigate = useNavigate(); // للتنقل بين الصفحات

  // حالة لتخزين بيانات المريض
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // حالة لتخزين فهرس الزيارة المختارة لعرض تفاصيلها
  const [selectedVisitIndex, setSelectedVisitIndex] = useState(0); // افتراضيًا، عرض أحدث زيارة (الفهرس 0)

  // useEffect لجلب بيانات المريض عند تحميل المكون أو تغيير الـ ID
  useEffect(() => {
    const fetchPatientData = async () => {
      setLoading(true);
      setError(null);
      try {
        // هنا يمكنك استدعاء API لجلب بيانات المريض الحقيقية بناءً على الـ ID
        // مثال: const response = await fetch(`/api/patients/${id}`);
        //       const data = await response.json();
        //       setPatientData(data);

        // بيانات مريض وهمية للعرض التوضيحي مع زيارات متعددة
        const mockData = {
          id: id || '12345678912',
          name: 'Nour Ali',
          bloodType: '+A',
          gender: 'Male',
          dateOfBirth: '05/13/1990',
          telephone: '01111112233',
          maritalStatus: 'Single',
          occupation: 'Front end developer',
          email: 'NourAli1990@gmail.com',
          address: 'Cairo, 23 Alsalim Street',
          // بيانات الزيارات التاريخية
          visits: [
            {
              visitDate: '2024-07-28', // أحدث زيارة
              vitals: {
                height: 190,
                weight: 90,
                bmi: 24.9,
                arterialBloodOxygen: 110,
                respiratoryRate: 16,
                bloodPressure: '120/80',
                pulse: 80,
                temperature: 37,
              },
              diagnosis: {
                diseaseName: 'Kidney failure',
                classification: 'Acute kidney injury (AKI)',
                organsHarmed: 'Kidney',
                lastObservation: '03/03/2019',
                timesOfInjury: 3,
                timeStamp: '03/03/2019 09:50 AM',
                clinicalNote: 'dehydration, blood loss, or exposure to toxins or drugs.',
              },
              conditions: {
                conditions: 'Chronic Gastritis',
                onSetDate: '2023-01-10',
                activation: 'Active',
                action: 'Medication review',
                endDate: 'N/A',
              },
              medicationOther: {
                drug: 'Omeprazole',
                food: 'Dairy products (avoid)',
                other: 'No known other issues.',
                comment: 'Patient shows good response to current treatment plan.',
                reaction: 'N/A',
                severity: 'Moderate',
              },
              attachments: [
                { id: 1, src: backImage, comment: 'Initial X-ray scan' },
                { id: 2, src: backImage, comment: 'Lab results (blood work)' },
              ],
              modelResults: {
                classificationImage: backImage,
                classificationComment: 'Normal-cecum',
                segmentationImage: backImage,
                segmentationComment: 'Segmented region of interest.',
              },
              soapNotes: {
                subjective: "Patient reports persistent abdominal pain, nausea, and occasional vomiting for the past week. Pain is described as dull and constant, worse after meals.",
                objective: "Abdominal tenderness on palpation in the epigastric region. No rebound tenderness. Bowel sounds normal. Vital signs within normal limits. Labs pending.",
                assessment: "Acute gastritis, possibly exacerbated by dietary factors. Rule out H. pylori infection.",
                plan: "1. Prescribe Omeprazole 20mg BID for 4 weeks. 2. Advise bland diet, avoid spicy/fatty foods, caffeine, and alcohol. 3. Order H. pylori breath test. 4. Follow-up in 2 weeks with lab results."
              }
            },
            {
              visitDate: '2023-11-15', // زيارة أقدم
              vitals: {
                height: 188,
                weight: 88,
                bmi: 24.8,
                arterialBloodOxygen: 108,
                respiratoryRate: 18,
                bloodPressure: '118/78',
                pulse: 78,
                temperature: 36.8,
              },
              diagnosis: {
                diseaseName: 'GERD',
                classification: 'Chronic',
                organsHarmed: 'Esophagus',
                lastObservation: '2023-11-15',
                timesOfInjury: 1,
                timeStamp: '2023-11-15 10:00 AM',
                clinicalNote: 'Patient presented with heartburn and indigestion.',
              },
              conditions: {
                conditions: 'N/A',
                onSetDate: 'N/A',
                activation: 'N/A',
                action: 'N/A',
                endDate: 'N/A',
              },
              medicationOther: {
                drug: 'Antacids',
                food: 'Spicy food (avoid)',
                other: 'N/A',
                comment: 'Advised lifestyle modifications.',
                reaction: 'N/A',
                severity: 'Mild',
              },
              attachments: [],
              modelResults: {
                classificationImage: backImage,
                classificationComment: 'No significant findings',
                segmentationImage: backImage,
                segmentationComment: 'N/A',
              },
              soapNotes: {
                subjective: "Patient reports recurring heartburn, especially after meals and at night.",
                objective: "No significant physical findings. Endoscopy not performed.",
                assessment: "Gastroesophageal Reflux Disease (GERD).",
                plan: "1. Advise dietary changes (avoid triggers). 2. Prescribe OTC antacids PRN. 3. Consider PPI if symptoms persist. 4. Follow-up in 1 month."
              }
            },
            // يمكنك إضافة المزيد من الزيارات هنا
          ],
        };
        setPatientData(mockData);
      } catch (err) {
        setError("Error fetching patient data: " + err.message);
        console.error("Error fetching patient data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPatientData();
  }, [id]); // يعاد تشغيل التأثير عند تغيير معرف المريض

  // وظيفة لحذف السجل (محاكاة)
  const handleDeleteRecord = () => {
    // استخدام confirm() كمحاكاة. في تطبيق حقيقي، استخدمي modal مخصص.
    if (window.confirm("Are you sure you want to delete this record?")) {
      console.log(`Deleting record for patient ID: ${patientData.id}`);
      // هنا يمكن إضافة منطق استدعاء API للحذف
      alert("Record deleted successfully! (Simulated)");
      navigate('/search-patient'); // العودة إلى صفحة البحث بعد الحذف
    }
  };

  // وظيفة للطباعة
  const handlePrint = () => {
    window.print(); // تفتح نافذة الطباعة الافتراضية للمتصفح
  };

  // تحديد بيانات الزيارة المختارة للعرض
  const selectedVisitData = patientData?.visits[selectedVisitIndex] || {};
  const patientPersonalInfo = patientData || {}; // المعلومات الشخصية تبقى ثابتة للمريض

  // عرض رسالة التحميل
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <p className="text-xl text-gray-700">Loading patient record...</p>
      </div>
    );
  }

  // عرض رسالة الخطأ
  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-red-100">
        <p className="text-xl text-red-700">Error: {error}</p>
      </div>
    );
  }

  // عرض رسالة إذا لم يتم العثور على بيانات
  if (!patientData) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <p className="text-xl text-gray-700">Patient record not found.</p>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen bg-cover bg-fixed bg-center p-4 md:p-8 relative" 
      style={{ backgroundImage: `url(${backImage})` }}
    >
      {/* أيقونة Noo Logo في الزاوية العلوية اليسرى */}
      <div className="absolute top-12 left-12 z-20">
        <Link to="/home"> {/* يمكن أن تكون رابطًا للصفحة الرئيسية أو أي صفحة أخرى */}
          <img src={nooLogo} alt="Drogastro Logo" className="w-15 h-12" /> {/* ضبط الحجم حسب الحاجة */}
        </Link>
      </div>

      {/* حاوية البيانات الرئيسية - استخدام Grid لتخطيط متجاوب */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-4 bg-white bg-opacity-80 rounded-lg shadow-xl">
        {/* أزرار الإجراءات في أعلى الفورم */}
        <div className="col-span-1 lg:col-span-2 flex flex-wrap justify-end items-center gap-4 mb-6">
          {/* زر الرجوع - الآن جزء من مجموعة الأزرار */}
          <Link to="/home" className="flex items-center bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md shadow-md transition-colors duration-200">
            <img src={leftArrowIcon} alt="Back" className="w-5 h-5 mr-2" /> Back to Home
          </Link>
          
          {/* زر الطباعة الجديد */}
          <button 
            onClick={handlePrint} 
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md shadow-md transition-colors duration-200"
          >
            Print Record
          </button>

          <button 
            onClick={handleDeleteRecord} 
            className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-md shadow-md transition-colors duration-200"
          >
            Delete Record
          </button>
          <Link 
            to="/register-patient" // يمكن تعديل هذا المسار لصفحة التعديل الفعلية
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md shadow-md transition-colors duration-200"
          >
            Diagnosis History
          </Link>
          <Link 
            to="/diagnosis-model" 
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md shadow-md transition-colors duration-200"
          >
            Diagnosis Model
          </Link>
        </div>

        {/* Visit History Selector */}
        <div className="col-span-1 lg:col-span-2 p-4 bg-white bg-opacity-70 rounded-lg shadow-md mb-4">
          <label htmlFor="visit-selector" className="block text-xl font-bold text-gray-800 mb-2">Select Visit Date:</label>
          <select
            id="visit-selector"
            className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-700"
            value={selectedVisitIndex}
            onChange={(e) => setSelectedVisitIndex(parseInt(e.target.value))}
          >
            {patientData.visits.map((visit, index) => (
              <option key={index} value={index}>
                {visit.visitDate}
              </option>
            ))}
          </select>
        </div>

        {/* Item 1: Personal Information (Static for the patient, not per visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md col-span-1 lg:col-span-2">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
            <img src={manImage} alt="Patient" className="w-32 h-32 object-cover rounded-full border-2 border-blue-400 flex-shrink-0" />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 w-full text-lg">
              <p><strong>Name:</strong> {patientPersonalInfo.name}</p>
              <p><strong>Blood Type:</strong> {patientPersonalInfo.bloodType}</p>
              <p><strong>ID:</strong> {patientPersonalInfo.id}</p>
              <p><strong>Gender:</strong> {patientPersonalInfo.gender}</p>
              <p><strong>Date Of Birth:</strong> {patientPersonalInfo.dateOfBirth}</p>
              <p><strong>Telephone:</strong> {patientPersonalInfo.telephone}</p>
              <p><strong>Marital Status:</strong> {patientPersonalInfo.maritalStatus}</p>
              <p><strong>Occupation:</strong> {patientPersonalInfo.occupation}</p>
              <p><strong>Email:</strong> {patientPersonalInfo.email}</p>
              <p><strong>Address:</strong> {patientPersonalInfo.address}</p>
            </div>
          </div>
        </div>

        {/* Item 2: Vital Signs (Dynamic based on selected visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md">
          <h4 className="text-xl font-bold mb-2 text-gray-800">Vital Signs - {selectedVisitData.visitDate}</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-lg">
            <p><strong>Height(cm):</strong> {selectedVisitData.vitals?.height || 'N/A'}</p>
            <p><strong>Weight(kg):</strong> {selectedVisitData.vitals?.weight || 'N/A'}</p>
            <p><strong>BMI:</strong> {selectedVisitData.vitals?.bmi || 'N/A'}</p>
            <p><strong>Arterial blood oxygen:</strong> {selectedVisitData.vitals?.arterialBloodOxygen || 'N/A'}</p>
            <p><strong>Respiratory Rate:</strong> {selectedVisitData.vitals?.respiratoryRate || 'N/A'}</p>
            <p><strong>Blood Pressure:</strong> {selectedVisitData.vitals?.bloodPressure || 'N/A'}</p>
            <p><strong>Pulse:</strong> {selectedVisitData.vitals?.pulse || 'N/A'}</p>
            <p><strong>Temperature(°c):</strong> {selectedVisitData.vitals?.temperature || 'N/A'}</p>
          </div>
        </div>

        {/* Item 3: Disease Information (Dynamic based on selected visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md">
          <h4 className="text-xl font-bold mb-2 text-gray-800">Diagnosis - {selectedVisitData.visitDate}</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-lg">
            <p><strong>Disease Name:</strong> {selectedVisitData.diagnosis?.diseaseName || 'N/A'}</p>
            <p><strong>Classification:</strong> {selectedVisitData.diagnosis?.classification || 'N/A'}</p>
            <p><strong>Organs Harmed:</strong> {selectedVisitData.diagnosis?.organsHarmed || 'N/A'}</p>
            <p><strong>Last Observation:</strong> {selectedVisitData.diagnosis?.lastObservation || 'N/A'}</p>
            <p><strong>Times Of Injury:</strong> {selectedVisitData.diagnosis?.timesOfInjury || 'N/A'}</p>
            <p><strong>TimeStamp:</strong> {selectedVisitData.diagnosis?.timeStamp || 'N/A'}</p>
            <p className="col-span-full"><strong>Clinical Note:</strong> {selectedVisitData.diagnosis?.clinicalNote || 'N/A'}</p>
          </div>
        </div>

        {/* Item 4: Conditions (Dynamic based on selected visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md">
          <h4 className="text-xl font-bold mb-2 text-gray-800">Conditions - {selectedVisitData.visitDate}</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-lg">
            <p><strong>Conditions:</strong> {selectedVisitData.conditions?.conditions || 'N/A'}</p>
            <p><strong>OnSet Date:</strong> {selectedVisitData.conditions?.onSetDate || 'N/A'}</p>
            <p><strong>Activation:</strong> {selectedVisitData.conditions?.activation || 'N/A'}</p>
            <p><strong>Action:</strong> {selectedVisitData.conditions?.action || 'N/A'}</p>
            <p><strong>End Date:</strong> {selectedVisitData.conditions?.endDate || 'N/A'}</p>
          </div>
        </div>

        {/* Item 5: Medication & Other Info (Dynamic based on selected visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md">
          <h4 className="text-xl font-bold mb-2 text-gray-800">Allergy - {selectedVisitData.visitDate}</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-lg">
            <p><strong>Drug:</strong> {selectedVisitData.medicationOther?.drug || 'N/A'}</p>
            <p><strong>Food:</strong> {selectedVisitData.medicationOther?.food || 'N/A'}</p>
            <p><strong>Other:</strong> {selectedVisitData.medicationOther?.other || 'N/A'}</p>
            <p><strong>Comment:</strong> {selectedVisitData.medicationOther?.comment || 'N/A'}</p>
            <p><strong>Reaction:</strong> {selectedVisitData.medicationOther?.reaction || 'N/A'}</p>
            <p><strong>Severity:</strong> {selectedVisitData.medicationOther?.severity || 'N/A'}</p>
          </div>
        </div>

        {/* NEW: Item for SOAP Notes (Dynamic based on selected visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md col-span-1 lg:col-span-2">
          <h4 className="text-xl font-bold mb-2 text-gray-800">SOAP Notes - {selectedVisitData.visitDate}</h4>
          <div className="space-y-4 text-lg">
            <p><strong>Subjective:</strong> {selectedVisitData.soapNotes?.subjective || 'N/A'}</p>
            <p><strong>Objective:</strong> {selectedVisitData.soapNotes?.objective || 'N/A'}</p>
            <p><strong>Assessment:</strong> {selectedVisitData.soapNotes?.assessment || 'N/A'}</p>
            <p><strong>Plan:</strong> {selectedVisitData.soapNotes?.plan || 'N/A'}</p>
          </div>
        </div>

        {/* Item 6: Attachments (Dynamic based on selected visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md col-span-1 lg:col-span-2">
          <h4 className="text-xl font-bold mb-4 text-gray-800">Attachments - {selectedVisitData.visitDate}</h4>
          <div className="flex flex-wrap justify-center gap-4">
            {selectedVisitData.attachments?.length > 0 ? (
              selectedVisitData.attachments.map((attachment, index) => (
                <div key={index} className="flex flex-col items-center">
                  <img src={attachment.src} alt={`Attachment ${index + 1}`} className="w-60 h-40 object-cover rounded-md border border-gray-300 shadow-sm" />
                  <p className="text-sm mt-2 text-center text-gray-700">Comment: {attachment.comment}</p>
                </div>
              ))
            ) : (
              <p className="text-gray-600">No attachments found for this visit.</p>
            )}
          </div>
        </div>

        {/* Item 7: Classification & Segmentation Images (Dynamic based on selected visit) */}
        <div className="p-4 bg-white bg-opacity-70 rounded-lg shadow-md col-span-1 lg:col-span-2">
          <h4 className="text-xl font-bold mb-4 text-gray-800">Model Results - {selectedVisitData.visitDate}</h4>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="flex flex-col items-center">
              <img src={selectedVisitData.modelResults?.classificationImage || backImage} alt="Classification" className="w-60 h-40 object-cover rounded-md border border-gray-300 shadow-sm" />
              <p className="text-sm mt-2 text-center text-gray-700">Classification: {selectedVisitData.modelResults?.classificationComment || 'N/A'}</p>
            </div>
            <div className="flex flex-col items-center">
              <img src={selectedVisitData.modelResults?.segmentationImage || backImage} alt="Segmentatio" className="w-60 h-40 object-cover rounded-md border border-gray-300 shadow-sm" />
              <p className="text-sm mt-2 text-center text-gray-700">Segmentation: {selectedVisitData.modelResults?.segmentationComment || 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowPatient;
